<section class="ca-title-container">
	<div class="ca-title-card-container">
		<div class="ca-title-card">
			{{title}}
		</div>

		<app-link-to-youtube *ngIf="learnAboutCharametricsURL" [url]="learnAboutCharametricsURL"></app-link-to-youtube>

	</div>
</section>
